import { MinusCircle as DeleteIcon } from 'lucide-react';
import React, { useContext, useEffect, useState } from 'react';
import { Button, IconButton } from './components/Button';
import { DateInput } from './components/DateInput';
import { Flex } from './components/Flex';
import { Input } from './components/Input';
import { Popover } from './components/Popover';
import { Rating } from './components/Rating';
import { getRating } from './helpers';
import { UserContext } from './UserContext';

export function SetRatingPopup({
  movie,
  open,
  anchorEl,
  onClose,
  onRatingChanged,
}) {
  const user_data = useContext(UserContext);

  const currentRating = getRating(movie, Number(user_data.id)) || null;
  const [rating, setRating] = useState(currentRating);
  const [prevRating, setPrevRating] = useState(currentRating);
  const [comment, setComment] = useState('');
  const [date, setDate] = useState(new Date());

  function saveRatingInfo() {
    var info = {
      rating: rating,
      comment: rating || comment != '' ? comment : null,
      rating_date: rating ? date : null,
      movie_id: movie.id,
      watchlisted: false,
      user_id: user_data.id,
    };
    onRatingChanged(info);
  }

  useEffect(() => {
    if (rating !== prevRating) {
      saveRatingInfo();
      setPrevRating(rating);
    }
  }, [rating]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      className="movie-modal__ratingPopover"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={onClose}
    >
      <Flex style={{ minWidth: '30vw' }} direction="column" gap="0.75rem">
        <Flex direction="column" gap="0.5rem">
          <Flex direction="row" justify="space-between" align="center">
            <Rating
              className="rating--large"
              precision={0.5}
              onChange={(e, newValue) => {
                setRating(newValue);
              }}
              value={rating}
            />
            {rating && (
              <IconButton
                className="ratingButton"
                title="Remove rating"
                onClick={() => {
                  setRating(null);
                }}
              >
                <DeleteIcon size={24} />
              </IconButton>
            )}
          </Flex>
          <DateInput
            value={date}
            onChange={(newValue) => setDate(newValue)}
            placeholder="Select date"
          />
        </Flex>
        <Input
          label=""
          multiline
          rows={4}
          placeholder="What are your thoughts?"
          maxLength={300}
          onChange={(e) => {
            setComment(e.target.value);
          }}
        />
        <Flex direction="column" gap="0.5rem">
          <Button variant="primary" onClick={saveRatingInfo} disabled={!rating}>
            Save
          </Button>
          {comment.length}/300
        </Flex>
      </Flex>
    </Popover>
  );
}
